import { render, staticRenderFns } from "./RocketIcon.vue?vue&type=template&id=4ef7b4db&scoped=true"
import script from "./RocketIcon.vue?vue&type=script&lang=js"
export * from "./RocketIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef7b4db",
  null
  
)

export default component.exports